import { E2eeReceiver } from 'features/e2ee/E2eeReceiver';
import type { DecryptionStrategy } from 'features/e2ee/core/decryption-strategies';
import { base64Decrypt } from 'features/e2ee/utils/base64Decrypt';
import type { EncryptedData } from 'features/e2ee/types';

export class ApplicationKeyDecryption implements DecryptionStrategy {
  canHandle(data: EncryptedData): boolean {
    return !!data.applicationKey;
  }

  async decrypt(data: EncryptedData, receiver: E2eeReceiver): Promise<void> {
    if (!receiver.sharedSecret) {
      throw new Error('Cannot decrypt application key. Shared secret is not defined');
    }

    const applicationKey = await base64Decrypt(data.applicationKey!, receiver.sharedSecret);
    await receiver.setApplicationKey(applicationKey);
  }
}
